// overridesStore.js
import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        // ===== EXISTING - Person-level override (DO NOT MODIFY) =====
        fixfloOverride: null,
        // ============================================================

        // ===== NEW - Company-level overrides (pre-populated for testing) =====
        companyOverrides: {
            //FixfloOverrideUrl: "www.google.com",
            //RemoveContactButtons: true,
            //RemoveMaintenanceJobs: true,
            //RemoveAffiliateLinks: true,
            //ReplacePhotoPlaceholder: true,
            //RemoveViewings: true,
            //RemovePropertyFeedback: true,
            //RemovePropertyRoomCounts: true,
            //RemoveTenantCerts: true,
            //HideMTDBanner: true,
            //HideSASAction: true
        },
        companyOverridesLoaded: false,
        companyOverridesCompanyName: null,
        companyOverridesError: null
        // ====================================================================
    },
    mutations: {
        // ===== EXISTING - Person-level override (DO NOT MODIFY) =====
        SET_FIXFLO_OVERRIDE(state, data) {
            state.fixfloOverride = data;
        },
        // ============================================================

        // ===== NEW - Company-level override mutations =====
        SET_COMPANY_OVERRIDES(state, data) {
            // Store the API response directly - fully dynamic
            state.companyOverrides = data || {};
            state.companyOverridesLoaded = true;
            state.companyOverridesError = null;
        },
        SET_COMPANY_OVERRIDES_COMPANY_NAME(state, companyName) {
            state.companyOverridesCompanyName = companyName;
        },
        SET_COMPANY_OVERRIDES_ERROR(state, error) {
            state.companyOverridesError = error;
            state.companyOverridesLoaded = false;
        },
        RESET_COMPANY_OVERRIDES(state) {
            state.companyOverrides = {};
            state.companyOverridesLoaded = false;
            state.companyOverridesCompanyName = null;
            state.companyOverridesError = null;
        }
        // =================================================
    },
    getters: {
        // ===== EXISTING - Person-level override (DO NOT MODIFY) =====
        fixfloOverride: state => state.fixfloOverride || null,
        // ============================================================

        // ===== NEW - Company-level override getters =====
        // Main getter - returns entire overrides object for direct property access
        companyOverrides: state => state.companyOverrides,

        // Status getters
        companyOverridesLoaded: state => state.companyOverridesLoaded,
        companyOverridesCompanyName: state => state.companyOverridesCompanyName,
        companyOverridesError: state => state.companyOverridesError,

        // Getter with fallback logic for FixfloOverrideUrl → fixfloOverride → null
        // This is the ONLY override that needs a dedicated getter due to legacy fallback requirement
        effectiveFixfloOverride: (state) => {
            // Priority 1: Check for company-level FixfloOverrideUrl
            const companyUrl = state.companyOverrides?.FixfloOverrideUrl;
            if (companyUrl && typeof companyUrl === 'string' && companyUrl.trim() !== '') {
                return companyUrl.trim();
            }

            // Priority 2: Fall back to person-level fixfloOverride
            const personOverride = state.fixfloOverride;
            if (personOverride && typeof personOverride === 'string' && personOverride.trim() !== '') {
                return personOverride.trim();
            }

            // Priority 3: No override exists
            return null;
        }
        // ===============================================
    },
    actions: {
        // ===== EXISTING - Person-level override (DO NOT MODIFY) =====
        getFixfloOverride({ commit }, payload) {
            const params = {
                body: {
                    clientName: payload.clientName,
                    personID: payload.personID
                }
            };

            return new Promise((resolve, reject) => {
                API_SERVICE.post("peoplePortalRestAPI", "/overrides/fixflo", params)
                    .then((response) => {
                        if (response.status === "200") {
                            commit("SET_FIXFLO_OVERRIDE", response.data);
                            resolve({
                                success: true,
                                data: response.data
                            });
                        } else {
                            commit("SET_FIXFLO_OVERRIDE", null);
                            reject({
                                success: false,
                                error: response.error
                            });
                        }
                    })
                    .catch((error) => {
                        commit("SET_FIXFLO_OVERRIDE", null);
                        reject({
                            success: false,
                            error: error.message
                        });
                    });
            });
        },
        // ============================================================

        // ===== NEW - Company-level override action =====
        getCompanyOverrides({ commit }, payload) {
            const params = {
                body: {
                    clientName: payload.clientName
                }
            };

            return new Promise((resolve, reject) => {
                API_SERVICE.post("peoplePortalRestAPI", "/overrides", params)
                    .then((response) => {
                        if (response.status === "200") {
                            commit("SET_COMPANY_OVERRIDES", response.data);
                            commit("SET_COMPANY_OVERRIDES_COMPANY_NAME", payload.clientName);
                            resolve({ success: true, data: response.data });
                        } else {
                            commit("SET_COMPANY_OVERRIDES_ERROR", response.error || "Failed to fetch");
                            reject({ success: false, error: response.error });
                        }
                    })
                    .catch((error) => {
                        commit("SET_COMPANY_OVERRIDES_ERROR", error.message);
                        reject({ success: false, error: error.message });
                    });
            });
        }
        // ==============================================
    }
}